import { EnrichmentDetail } from "@app/shared/models/enrichment-detail.model";

/** Top-level `EnrichmentDetail` keys that belong to each canonical tab.
 *  Used by per-tab language coverage to scope the walk so a tab's % only
 *  reflects fields the user can actually edit from that tab.
 *
 *  Unknown tabs fall back to the whole detail. */
export const TAB_DETAIL_KEYS: Readonly<
  Record<string, readonly (keyof EnrichmentDetail)[]>
> = {
  "price-config": ["prices"],
  category: ["shelves"],
  "package-settings": [
    "productOfferingTerm",
    "agreements",
    "networkType",
    "segment",
    "productEffectiveOption",
    "packageType",
    "offerClassificationName",
  ],
};

/** Tabs whose detail slice carries NO user-editable localized content, so
 *  language coverage must be forced to empty (no gaps). Special promotion's
 *  pricing logic is a code, not a locale bag, so there is nothing to
 *  translate. */
export const TABS_WITHOUT_LOCALE_COVERAGE: ReadonlySet<string> = new Set([
  "special-promotion",
]);

/** Returns the subtree(s) of `detail` that belong to `tabId`, or the full
 *  detail when the tab is not mapped. */
export function detailSliceForTab(
  detail: EnrichmentDetail | null | undefined,
  tabId: string,
): unknown {
  if (!detail) return null;
  const keys = TAB_DETAIL_KEYS[tabId];
  if (!keys) return detail;
  const slice: Record<string, unknown> = {};
  for (const key of keys) {
    slice[key] = detail[key];
  }
  return slice;
}
